// meta tag per le pagine dinamiche (titolo, descrizione, Open Graph); ripristino all'uscita
import { canonicalUrl, socialImageUrl } from "./site";

const DEFAULT_TITLE = "APF Partners — Firmiamo la tua crescita, non lo store.";
const DEFAULT_DESCRIPTION = document.head.querySelector('meta[name="description"]').content;

const upsert = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const setMeta = ({ title, description = DEFAULT_DESCRIPTION, image, url = window.location.pathname, type = "article" }) => {
    const canonical = canonicalUrl(url);
    const socialImage = socialImageUrl(image);
    document.title = title ? `${title} — APF Partners` : DEFAULT_TITLE;
    upsert("name", "description", description);
    upsert("property", "og:description", description);
    upsert("property", "og:title", title || DEFAULT_TITLE);
    upsert("property", "og:type", type);
    upsert("property", "og:url", canonical);
    upsert("property", "og:image", socialImage);
    upsert("name", "twitter:title", title || DEFAULT_TITLE);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:url", canonical);
    upsert("name", "twitter:image", socialImage);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
};

export const resetMeta = () => {
    setMeta({ type: "website" });
};
